<div class="dialog-pqr">
  <div class="header">
    <h2 mat-dialog-title>Valores do padrão de qualidade de referência - PQR</h2>

    <mat-dialog-actions>
      <button mat-dialog-close class="close-x-button">×</button>
    </mat-dialog-actions>
  </div>

  <mat-dialog-content>
    <h1 class="title">Número de dias letivos</h1>
    <div class="panel">
      <app-tabela
        ngSkipHydration
        class="table-component"
        [cabecalhoCustomizado]="true"
      >
        <ng-container cabecalho>
          <tr>
            <th class="table-header" style="width: 50%">Etapa</th>
            <th class="table-header" style="width: 50%">
              Número de dias letivos (PQR)
            </th>
          </tr>
        </ng-container>
        <ng-container corpo>
          <ng-container *ngFor="let dados of pqrNumeroDiasLetivosPadrao">
            <tr>
              <td class="table-cell align-left">{{ dados.etapaEnsino.descricao }}</td>
              <td class="table-cell">
                <input
                  [value]="dados.qntDiasLetivos"
                  class="display-input text-green"
                  disabled="true"
                  maxlength="2"
                />
              </td>
            </tr>
          </ng-container>
        </ng-container>
      </app-tabela>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="footer">
    <button class="close-button" mat-dialog-close>Fechar</button>
  </mat-dialog-actions>
</div>
